<template>
  <div class="apps">
    <p class="apps__title">{{ $t("Download now") }}</p>
    <div class="apps__wrapper">
      <div class="app app__ultimaWallet">
        <p class="app__title">Ultima</p>
        <p class="app__subtitle">Wallet</p>
        <gl-svg-icon
          class="app__icon"
          icon="ultima-wallet"
          width="96"
          height="96"
        />
        <a :href="appWalletApple" target="_blank">
          <img :src="require(`img/apps/AppStore.png`)" class="app__appStore" />
        </a>
        <a :href="appWalletGoogle" target="_blank">
          <img :src="require(`img/apps/GooglePlay.png`)" class="app__googlePlay" />
        </a>
      </div>
      <div class="app__image">
        <img :src="require('img/landing/phones.png')" />
      </div>
      <div class="app app__ultimaFarm">
        <p class="app__title">Ultima</p>
        <p class="app__subtitle">Farm</p>
        <gl-svg-icon
          class="app__icon"
          icon="ultima-farm"
          width="96"
          height="96"
        />
        <a :href="appFarmApple" target="_blank">
          <img :src="require(`img/apps/AppStore.png`)" class="app__appStore" />
        </a>
        <a :href="appFarmGoogle" target="_blank">
          <img :src="require(`img/apps/GooglePlay.png`)" class="app__googlePlay" />
        </a>
      </div>
    </div>

    <div class="apps__btnWrapper">
      <a :href="toRegistration" target="_blank" class="apps__btn">{{ $t("Sign up") }}</a>
    </div>
  </div>
</template>

<script>
import GlSvgIcon from "@gl/GlSvgIcon.vue";
import { appWalletApple, appWalletGoogle, appFarmGoogle, appFarmApple } from "@/config";
import { toRegistration } from "@/tools";

export default {
  name: "Apps",
  components: { GlSvgIcon },
  data() {
    return {
      appWalletApple, appWalletGoogle, appFarmGoogle, appFarmApple
    }
  },
  computed: {
    toRegistration,
  }
};
</script>

<style lang="scss" scoped>
.apps {
  padding: 64px 16px;

  @media (min-width: $breakpoint-xl) {
    padding: 64px 82px;
  }

  @media (min-width: $breakpoint-xl) {
    padding: 96px 0;
  }

  &__title {
    text-align: center;
    font-family: $font-secondary;
    font-size: 20px;
    line-height: 32px;
    font-weight: 700;
    color: #333333;

    @media (min-width: $breakpoint-xl) {
      font-size: 24px;
      line-height: 48px;
    }
  }

  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  &__btnWrapper {
    display: flex;
    justify-content: center;
  }

  &__btn {
    padding: 20px 0px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
    line-height: 24px;
    width: 100%;
    background-color: $color-blue-4;
    margin-top: 32px;

    &:hover {
      background-color: #1f4776;
    }

    &:active {
      background-color: #18375b;
    }

    @media (min-width: $breakpoint-md) {
      max-width: 224px;
      margin-top: 18x;
    }
    @media (min-width: $breakpoint-xl) {
      max-width: 268px;
      margin-top: 22px;
    }
  }
}

.app {
  text-align: center;
  font-family: $font-secondary;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  width: 50%;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: $breakpoint-xl) {
    font-size: 18px;
    width: initial;
  }

  &__ultimaWallet {
    order: 1;
    margin-top: 48px;
  }

  &__image {
    order: 3;
    margin-top: 8px;
    @media (min-width: $breakpoint-md) {
      max-width: 540px;
    }
    @media (min-width: $breakpoint-xl) {
      margin-top: 16px;

      order: 2;
    }
  }

  &__ultimaFarm {
    margin-top: 48px;
    order: 2;
    @media (min-width: $breakpoint-xl) {
      order: 3;
    }
  }

  &__subtitle {
    color: #3a8ec8;
  }

  &__icon {
    margin-top: 8px;

    @media (min-width: $breakpoint-xl) {
      margin-top: 16px;
    }
  }

  &__googlePlay {
    margin-top: 8px;
    max-width: 120px;
    @media (min-width: $breakpoint-md) {
      max-width: 100%;
    }
  }

  &__appStore {
    margin-top: 48px;
    max-width: 120px;
    @media (min-width: $breakpoint-md) {
      max-width: 100%;
    }
    @media (min-width: $breakpoint-xl) {
      margin-top: 64px;
    }
  }
}
</style>
